export class RequestLot {
    installationDate: Date; }
